/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// For slick slider
$(document).ready(function () {
  function positionArrowsFeatured() {
    const img = document.querySelector('.featured-collections-new .slick-slide .product-item__image-wrapper');

    if (!img) return;

    const imgHeight = img.offsetHeight;
    console.log("imgHeight" + imgHeight);

    document.querySelectorAll('.featured-collections-new .slick-arrow').forEach(arrow => {
      arrow.style.top = (imgHeight / 2) + 32 + 'px';
    });
  }

  $(".featured-collections-new .product-list-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: $(".featured-collections-new .slick-prev.slick-arrow-custom"),
    nextArrow: $(".featured-collections-new .slick-next.slick-arrow-custom"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 2,
        },
      },
    ],
  });

  $(".featured-collections-new .product-list-slider").on('init', function (event, slick) {
    positionArrowsFeatured();
  }).on('setPosition', function (event, slick) {
    positionArrowsFeatured();
  })
    .on('afterChange', function (event, slick) {
      positionArrowsFeatured();
    });

  $(".slick-slider:not(.slick-initialized)").slick({
    dots: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          centerMode: true,
          centerPadding: "35px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  const appsSection = document.querySelector(".shopify-section--apps");

  if (appsSection) {
    const observer = new MutationObserver((mutations, obs) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const starsEl = node.querySelector?.(".jdgm-rev-widg__summary-stars");

          if (starsEl) {
            const ariaLabel = starsEl.getAttribute("aria-label") || "";
            const match = ariaLabel.match(/\b\d+\.\d+\b/);
            const rating = match ? match[0] : null;

            console.log("Extracted rating:", rating);

            obs.disconnect();
            return;
          }
        }
      }
    });

    observer.observe(appsSection, {
      childList: true,
      subtree: true,
    });
  }

  // Subscripting product titles inside Tolstoy carousel
  const tolstoyCarouselParent = document.querySelector(
    ':is(.shopify-app-block[id*="tolstoy_shoppable_video"] .tolstoy-carousel, .shopify-app-block tolstoy-carousel.tolstoy-carousel)'
  );

  const config = {
    childList: true,
    subtree: false,
  };

  const tolstoyObserver = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((el) => {
          tolstoyCarouselParent
            .querySelectorAll(".tolstoy-product-tile-title")
            .forEach((el) => {
              el.innerHTML = el.innerHTML
                .replace(/(?<!<sub>)(&reg;|®)(?!<\/sub>)/g, "<sub>®</sub>")
                .replace(/(?<!<sub>)(&trade;|™)(?!<\/sub>)/g, "<sub>™</sub>");
            });
        });
      }
    }
  });

  if (tolstoyCarouselParent) {
    tolstoyObserver.observe(tolstoyCarouselParent, config);
  }
});

//code for fix issue with the double add to cart issue 
(function () {
  const submittingForms = new WeakSet();

  function isProductForm(form) {
    return (
      form instanceof HTMLFormElement &&
      form.getAttribute("is") === "product-form"
    );
  }

  function getSubmitButtons(form) {
    return Array.from(form.elements).filter(
      (element) => element?.type === "submit"
    );
  }

  function toggleSubmitButtons(form, isLoading) {
    getSubmitButtons(form).forEach((button) => {
      if (isLoading) {
        button.setAttribute("disabled", "disabled");
        button.setAttribute("aria-busy", "true");
      } else {
        button.removeAttribute("disabled");
        button.removeAttribute("aria-busy");
      }
    });
  }

  async function handleProductFormSubmit(form) {
    if (submittingForms.has(form)) {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    submittingForms.add(form);
    toggleSubmitButtons(form, true);

    const productForm = new FormData(form);
    productForm.set("sections", "mini-cart");
    productForm.delete("option1");
    productForm.delete("option2");
    productForm.delete("option3");

    const variantId = productForm.get("id");
    if (variantId) {
      productForm.delete("id");
      productForm.set("id", variantId);
    }

    const sellingPlan = productForm.get("selling_plan");
    if (!sellingPlan) {
      productForm.delete("selling_plan");
    } else {
      productForm.delete("selling_plan");
      productForm.set("selling_plan", sellingPlan);
    }

    let response;
    let responseJson;

    try {
      response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
        body: productForm,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      responseJson = await response.json();
    } finally {
      submittingForms.delete(form);
      toggleSubmitButtons(form, false);
    }

    if (response.ok) {
      if (
        window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart"
      ) {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      form.dispatchEvent(
        new CustomEvent("variant:added", {
          bubbles: true,
          detail: {
            variant: responseJson.hasOwnProperty("items")
              ? responseJson.items[0]
              : responseJson,
          },
        })
      );

      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (cartResponse) => {
          const cartContent = await cartResponse.json();

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent,
              },
            })
          );

          cartContent.sections = responseJson.sections;

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart:
                  window.themeVariables.settings.cartType === "drawer" &&
                  form.closest(".drawer") === null,
              },
            })
          );
        }
      );
    }

    form.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson.description || "",
        },
      })
    );
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;

      if (!isProductForm(form)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      handleProductFormSubmit(form);
    },
    true
  );
})();
